export enum EBool {
  EBool_UNKNOWN = 0,
  EBool_FALSE = 1,
  EBool_TRUE = 2,
}

export namespace EBool {
  // True && Unknown = True
  export function toBool(src: EBool): boolean {
    return src !== EBool.EBool_FALSE;
  }

  export function fromBool(src: boolean): EBool {
    return src ? EBool.EBool_TRUE : EBool.EBool_FALSE;
  }

  export function toBoolString(src: EBool): string {
    return src === EBool.EBool_TRUE ? 'True' : 'False';
  }

  export function fromBoolString(src: string): EBool {
    return src === 'True' || src === 'true' ? EBool.EBool_TRUE : EBool.EBool_FALSE;
  }

  export function isTrue(src: EBool): boolean {
    return src === EBool.EBool_TRUE;
  }

  export function reverse(src: EBool, def: EBool = EBool.EBool_UNKNOWN): EBool {
    switch (src) {
      case EBool.EBool_FALSE:
        return EBool.EBool_TRUE;
      case EBool.EBool_TRUE:
        return EBool.EBool_FALSE;
      default:
        console.error('EBool is set to unknown');
        return def;
    }
  }
}
